(() => {
  if (window.MybePaymentFeeCountSyncV8) return;
  window.MybePaymentFeeCountSyncV8 = true;

  const isFee = item => {
    const title = String(item.product_title || item.title || '').toLowerCase();
    const handle = String(item.handle || item.product_handle || '').toLowerCase();
    return title.includes('payment fee') || handle.includes('payment-fee');
  };

  const apply = cart => {
    if (!cart || !Array.isArray(cart.items)) return;
    const count = cart.items.reduce((sum, item) =>
      sum + (isFee(item) ? 0 : Number(item.quantity || 0)), 0);
    document.querySelectorAll('cart-count').forEach(node => {
      node.textContent = String(count);
      node.hidden = count === 0;
      node.setAttribute('aria-label', `${count} items in cart`);
    });
  };

  const onCartUpdate = event => {
    if (window.MybeCardQuickQty?.isBusy?.()) return;
    const cart = event?.cart || event?.detail?.cart || event?.detail;
    if (cart) apply(cart);
  };

  const syncInitial = () => {
    const readCart = window.MybeInitialCart?.load
      ? window.MybeInitialCart.load()
      : fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers:{Accept:'application/json'}, cache:'no-store'
        }).then(response => {
          if (!response.ok) throw new Error('Cart count sync failed');
          return response.json();
        });
    readCart.then(cart => {
      if (!window.MybeCardQuickQty?.isBusy?.()) apply(window.MybeCartWriteQueue?.lastCart || cart);
    })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitial, {once:true});
  } else {
    syncInitial();
  }

  document.addEventListener('cart:updated', onCartUpdate);
  if (window.theme?.pubsub?.subscribe && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
})();
